/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { GuardedLaunch, GuardedLaunchInterface } from "../GuardedLaunch";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "GlobalLimitDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "GlobalPauseDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "ManagerDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "ManagerIsZero",
    type: "error",
  },
  {
    inputs: [],
    name: "MaxLiquidityDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyOwnerOrManager",
    type: "error",
  },
  {
    inputs: [],
    name: "SiloMaxLiquidityDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "SiloPauseDidNotChange",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newMaxDeposits",
        type: "uint256",
      },
    ],
    name: "DefaultSiloMaxDepositsLimitUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "globalPause",
        type: "bool",
      },
    ],
    name: "GlobalPause",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "newLimitedMaxLiquidityState",
        type: "bool",
      },
    ],
    name: "LimitedMaxLiquidityToggled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "manager",
        type: "address",
      },
    ],
    name: "ManagerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newMaxDeposits",
        type: "uint256",
      },
    ],
    name: "SiloMaxDepositsLimitsUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "pauseValue",
        type: "bool",
      },
    ],
    name: "SiloPause",
    type: "event",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_manager",
        type: "address",
      },
    ],
    name: "changeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getMaxSiloDepositsValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [
      {
        internalType: "bool",
        name: "globalPause",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "isSiloPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "manager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxLiquidity",
    outputs: [
      {
        internalType: "bool",
        name: "globalLimit",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "defaultMaxLiquidity",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxDeposits",
        type: "uint256",
      },
    ],
    name: "setDefaultSiloMaxDepositsLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_globalPause",
        type: "bool",
      },
    ],
    name: "setGlobalPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_globalLimit",
        type: "bool",
      },
    ],
    name: "setLimitedMaxLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxDeposits",
        type: "uint256",
      },
    ],
    name: "setSiloMaxDepositsLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_pauseValue",
        type: "bool",
      },
    ],
    name: "setSiloPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b503361001b81610081565b6001600160a01b03811661004257604051639c774ebf60e01b815260040160405180910390fd5b600280546001600160a01b0319166001600160a01b03929092169190911790556003805460ff19166001179055680d8d726b7177a800006004556101e1565b6000546001600160a01b038083169116036100d75760405162461bcd60e51b81526020600482015260116024820152704f776e65724469644e6f744368616e676560781b60448201526064015b60405180910390fd5b600080546001600160a01b0319166001600160a01b038316908117825560405190917f04dba622d284ed0014ee4b9a6a68386be1a4c08a4913ae272de89199cc68616391a26001546001600160a01b03161561013757610137600061013a565b50565b6001546001600160a01b038083169116036101975760405162461bcd60e51b815260206004820152601860248201527f50656e64696e674f776e65724469644e6f744368616e6765000000000000000060448201526064016100ce565b600180546001600160a01b0319166001600160a01b0383169081179091556040517fd6aad444c90d39fb0eee1c6e357a7fad83d63f719ac5f880445a2beb0ff3ab5890600090a250565b610c63806101f06000396000f3fe608060405234801561001057600080fd5b50600436106101165760003560e01c806370c0345c116100a2578063a3fbbaae11610071578063a3fbbaae1461023b578063b187bd261461024e578063e30c39781461025b578063f2fde38b1461026c578063fa2a06391461027f57600080fd5b806370c0345c146101f2578063715018a61461021a57806379ba5097146102225780638da5cb5b1461022a57600080fd5b806344cf3e93116100e957806344cf3e9314610171578063481c6a751461019457806355a2cc71146101b957806356fecf1a146101cc57806369a6b3db146101df57600080fd5b806312d04a421461011b5780631b366533146101415780633278c6941461015657806344552b5d14610169575b600080fd5b61012e610129366004610af9565b610292565b6040519081526020015b60405180910390f35b61015461014f366004610b3c565b6102e8565b005b610154610164366004610b7f565b6103dd565b61015461042b565b61018461017f366004610af9565b610470565b6040519015158152602001610138565b6002546001600160a01b03165b6040516001600160a01b039091168152602001610138565b6101546101c7366004610b9a565b6104de565b6101546101da366004610bb5565b610581565b6101546101ed366004610b9a565b610604565b6003546004546102039160ff169082565b604080519215158352602083019190915201610138565b61015461069b565b6101546106de565b6000546001600160a01b03166101a1565b610154610249366004610b7f565b610745565b6006546101849060ff1681565b6001546001600160a01b03166101a1565b61015461027a366004610b7f565b61082d565b61015461028d366004610bce565b6108b3565b60035460009060ff16156102dd576001600160a01b0380841660009081526005602090815260408083209386168352929052205480156102d35790506102e2565b50506004546102e2565b506000195b92915050565b6002546001600160a01b031633146103135760405163605919ad60e11b815260040160405180910390fd5b6001600160a01b0380841660009081526007602090815260408083209386168352929052205481151560ff9091161515036103615760405163715c41ad60e01b815260040160405180910390fd5b6001600160a01b03838116600081815260076020908152604080832094871680845294825291829020805460ff19168615159081179091558251938452908301939093528101919091527f25679bcc320e874c367bc177e782eec47457781ade29259bcea7c3f1fd5c3ef59060600160405180910390a1505050565b336103f06000546001600160a01b031690565b6001600160a01b03161461041f5760405162461bcd60e51b815260040161041690610c0a565b60405180910390fd5b61042881610985565b50565b3361043e6000546001600160a01b031690565b6001600160a01b0316146104645760405162461bcd60e51b815260040161041690610c0a565b61046e6000610985565b565b60065460009060ff16806104a757506001600160a01b038316600090815260076020908152604080832083805290915290205460ff165b806104d757506001600160a01b0380841660009081526007602090815260408083209386168352929052205460ff165b9392505050565b6002546001600160a01b031633146105095760405163605919ad60e11b815260040160405180910390fd5b60035481151560ff9091161515036105345760405163c65b3d2960e01b815260040160405180910390fd5b6003805460ff191682151590811790915560405160ff909116151581527eace7bfa8dc4895fea42b63dd0304a5b26ee0982b8d764257b6b106b11a4541906020015b60405180910390a150565b6002546001600160a01b031633146105ac5760405163605919ad60e11b815260040160405180910390fd5b6004548190036105cf57604051633225cebb60e01b815260040160405180910390fd5b60048190556040518181527f5b71e2324e73b2492a36b7c5f86de1bd745d891c29c3fa39e1ed97960a259eb390602001610576565b6002546001600160a01b0316331461062f5760405163605919ad60e11b815260040160405180910390fd5b60065481151560ff90911615150361065a57604051634ad6576f60e01b815260040160405180910390fd5b6006805460ff19168215159081179091556040519081527fa5fea31b6dbd7aec6098ca4653b1d51af1ef786fcb19031c4c4e55b675535f1e90602001610576565b336106ae6000546001600160a01b031690565b6001600160a01b0316146106d45760405162461bcd60e51b815260040161041690610c0a565b61046e6000610a2c565b6001546001600160a01b0316331461072b5760405162461bcd60e51b815260206004820152601060248201526f27b7363ca832b73234b733a7bbb732b960811b6044820152606401610416565b61046e6107406001546001600160a01b031690565b610a2c565b6000546001600160a01b0316331480159061076b57506002546001600160a01b03163314155b156107895760405163b647320d60e01b815260040160405180910390fd5b6001600160a01b0381166107b057604051639c774ebf60e01b815260040160405180910390fd5b6002546001600160a01b03908116908216036107df57604051632ebe652b60e21b815260040160405180910390fd5b600280546001600160a01b0319166001600160a01b0383169081179091556040519081527f198db6e425fb8aafd1823c6ca50be2d51e5764571a5ae0f0f21c6812e45def0b90602001610576565b336108406000546001600160a01b031690565b6001600160a01b0316146108665760405162461bcd60e51b815260040161041690610c0a565b6001600160a01b0381166108aa5760405162461bcd60e51b815260206004820152600b60248201526a4f776e657249735a65726f60a81b6044820152606401610416565b61042881610a2c565b6002546001600160a01b031633146108de5760405163605919ad60e11b815260040160405180910390fd5b6001600160a01b038084166000908152600560209081526040808320938616835292905220548190036109245760405163ce9e721f60e01b815260040160405180910390fd5b6001600160a01b0383811660008181526005602090815260408083209487168084529482529182902085905590518481527f25c16b7d0bcf048ed0d91eb5e50591eb538c034fd4ebee6cac8b7c9cf77c770b910160405180910390a3505050565b6001546001600160a01b038083169116036109e25760405162461bcd60e51b815260206004820152601860248201527f50656e64696e674f776e65724469644e6f744368616e676500000000000000006044820152606401610416565b600180546001600160a01b0319166001600160a01b0383169081179091556040517fd6aad444c90d39fb0eee1c6e357a7fad83d63f719ac5f880445a2beb0ff3ab5890600090a250565b6000546001600160a01b03808316911603610a7d5760405162461bcd60e51b81526020600482015260116024820152704f776e65724469644e6f744368616e676560781b6044820152606401610416565b600080546001600160a01b0319166001600160a01b038316908117825560405190917f04dba622d284ed0014ee4b9a6a68386be1a4c08a4913ae272de89199cc68616391a26001546001600160a01b031615610428576104286000610985565b80356001600160a01b0381168114610af457600080fd5b919050565b60008060408385031215610b0c57600080fd5b610b1583610add565b9150610b2360208401610add565b90509250929050565b80358015158114610af457600080fd5b600080600060608486031215610b5157600080fd5b610b5a84610add565b9250610b6860208501610add565b9150610b7660408501610b2c565b90509250925092565b600060208284031215610b9157600080fd5b6104d782610add565b600060208284031215610bac57600080fd5b6104d782610b2c565b600060208284031215610bc757600080fd5b5035919050565b600080600060608486031215610be357600080fd5b610bec84610add565b9250610bfa60208501610add565b9150604084013590509250925092565b60208082526009908201526827b7363ca7bbb732b960b91b60408201526060019056fea2646970667358221220a9726b26438a7a5eb287f2378565214fb72410991eb4871b0dc8865b8cd9c53d64736f6c634300080d0033";

type GuardedLaunchConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GuardedLaunchConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GuardedLaunch__factory extends ContractFactory {
  constructor(...args: GuardedLaunchConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "GuardedLaunch";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GuardedLaunch> {
    return super.deploy(overrides || {}) as Promise<GuardedLaunch>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): GuardedLaunch {
    return super.attach(address) as GuardedLaunch;
  }
  connect(signer: Signer): GuardedLaunch__factory {
    return super.connect(signer) as GuardedLaunch__factory;
  }
  static readonly contractName: "GuardedLaunch";
  public readonly contractName: "GuardedLaunch";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GuardedLaunchInterface {
    return new utils.Interface(_abi) as GuardedLaunchInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GuardedLaunch {
    return new Contract(address, _abi, signerOrProvider) as GuardedLaunch;
  }
}
